import { render, staticRenderFns } from "./ReturnProduct.vue?vue&type=template&id=01fe46b2&scoped=true"
import script from "./ReturnProduct.vue?vue&type=script&lang=js"
export * from "./ReturnProduct.vue?vue&type=script&lang=js"
import style0 from "./ReturnProduct.vue?vue&type=style&index=0&id=01fe46b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fe46b2",
  null
  
)

export default component.exports